export function HeroIllustration() {
  return (
    <div className="hero-illustration" role="img" aria-label="A blueprint-style robot sensing obstacles and choosing a route">
      <svg viewBox="0 0 600 520" aria-hidden="true">
        <defs>
          <pattern id="hero-grid" width="28" height="28" patternUnits="userSpaceOnUse">
            <path d="M28 0H0V28" fill="none" className="grid-line" />
          </pattern>
          <marker id="arrowhead" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <path d="M0 0 7 3.5 0 7Z" className="arrow-fill" />
          </marker>
        </defs>
        <rect x="1" y="1" width="598" height="518" rx="26" className="blueprint-bg" />
        <rect x="1" y="1" width="598" height="518" rx="26" fill="url(#hero-grid)" />
        <g className="scan-lines">
          <path d="M300 339A136 136 0 0 1 435 204" />
          <path d="M300 339A201 201 0 0 1 500 139" />
          <path d="M300 339A265 265 0 0 1 565 74" />
        </g>
        <path className="route-line" d="M93 416c90 16 102-111 200-95s84-176 192-193" markerEnd="url(#arrowhead)" />
        <g className="obstacle">
          <rect x="130" y="246" width="58" height="72" rx="5" />
          <path d="m139 259 38 46m0-46-38 46" />
          <rect x="421" y="342" width="80" height="44" rx="5" />
          <path d="m431 352 60 24m0-24-60 24" />
        </g>
        <g className="robot" transform="translate(255 300)">
          <rect x="0" y="0" width="96" height="91" rx="22" />
          <circle cx="48" cy="25" r="16" />
          <circle cx="48" cy="25" r="5" />
          <path d="M19 58h58M26 70h44" />
          <circle cx="13" cy="79" r="14" />
          <circle cx="83" cy="79" r="14" />
        </g>
        <g className="annotation annotation-one">
          <rect x="42" y="40" width="180" height="80" rx="10" />
          <text x="62" y="72">PERCEIVE</text>
          <text x="62" y="98" className="annotation-small">vision / lidar / range</text>
          <path d="M205 112c35 33 50 56 64 91" markerEnd="url(#arrowhead)" />
        </g>
        <g className="annotation annotation-two">
          <rect x="371" y="416" width="184" height="61" rx="10" />
          <text x="390" y="452">ACT → ADAPT</text>
        </g>
        <g className="cross-marks">
          <path d="M516 52v26m-13-13h26M67 174v26m-13-13h26M545 277v20m-10-10h20" />
        </g>
      </svg>
      <span className="hero-figure-caption">FIG. 01 / perception → decision → motion</span>
    </div>
  );
}
